import User from "../model/User";
import { getBaseApiUrl, getUploadUrl, promiseRequest, promiseSendFormData } from "./ServiceApi";
import { ServiceApi } from "./ServiceApiWithLoading";

interface SetPasswordRequest {
    token: string,
    password: string
}

interface ForgotPasswordRequest {
    login: string
}

export default class UserApi extends ServiceApi<User>{

    constructor(loading: boolean = true) {
        super('user', loading);
    }

    async changePassword(id: string | number, old_password: string, new_password: string): Promise<boolean> {
        const url = `${this.getBaseUrl()}${id}/changePassword`;
        const result = await this.promiseWithLoading(promiseRequest(url, 'PUT', { old_password, new_password }));
        return result && result !== null;
    }

    async setPassword(item: SetPasswordRequest): Promise<boolean> {
        var baseUrl = this.getBaseUrl();
        var result = await this.promiseWithLoading(promiseRequest(baseUrl + `setPassword`, 'POST', item, false, false));
        return result !== null;
    }

    async forgotPassword(item: ForgotPasswordRequest): Promise<boolean> {
        var baseUrl = this.getBaseUrl();
        var result = await this.promiseWithLoading(promiseRequest(baseUrl + `forgotPassword`, 'POST', item, true, false));
        return result !== null;
    }

    async validateToken(token: string): Promise<boolean> {
        var baseUrl = this.getBaseUrl();
        const result = await this.promiseWithLoading(promiseRequest(baseUrl + `validateToken/${token}/`, 'GET', undefined, false, false));
        return (result && result === true);
    }

    async uploadPhoto(data: File, userId: number | string): Promise<any> {
        var baseUrl = this.getBaseUrl();
        const formData = new FormData();

        formData.append('photo', data);

        try {
            var result = await this.promiseWithLoading(promiseSendFormData(baseUrl + `${userId}/uploadPhoto/`, 'POST', formData));
            return result;
        } catch {
            return null;
        }
    }

    async deletePhoto(userId: number | string) {
        var baseUrl = this.getBaseUrl();
        var result = await this.promiseWithLoading(promiseRequest(baseUrl + `${userId}/deletePhoto/`, 'DELETE', {}, true));
        return result;
    }

    async getPhoto(userId: number | string, fileName: string): Promise<Blob|null>{
        let dir = `User/${userId}/${fileName}`;
        var url = getUploadUrl() + `${dir}`;
           
        let result = await this.promiseGetBlob(url, false);
        return result;
    }

    getPhotoUrl(userId: number | string, fileName: string): string {
        let dir = `User/${userId}/${fileName}`;
        return getUploadUrl() + `${dir}`;
    }

    async updateDepartments(userId: number | string, list: number[] | null) {
        var baseUrl = this.getBaseUrl();
        var result = await this.promiseWithLoading(promiseRequest(baseUrl + `${userId}/departments/`, 'PUT', list || undefined, true));
        return result;
    }
}